import * as claims from './claims'
import * as enums from './enums'
import * as formats from './formats'
import * as graphql from './graphql'
import * as langs from './langs'
import * as localStorage from './local-storage'
import * as prismic from './prismic'
import * as urls from './urls'

export default {
  claims,
  enums,
  formats,
  graphql,
  langs,
  localStorage,
  prismic,
  urls
}
